import React from "react";
import GloablButton from "../../components/GloablButton";
import { translateText, useTranslationSnapshot } from "./../../translations/runtime";


function AccountActionButton({
  children,
  className = "",
  color = "primary",
  disabled = false,
  onClick,
  type = "button",
  width = "102px",
}) {
  useTranslationSnapshot();
  const styles = {
    primary: { backgroundColor: "#ff9b00", color: "#ffffff" },
    dark: { backgroundColor: "#000000", color: "#ffffff" },
    danger: { backgroundColor: "#d62828", color: "#ffffff" },
  };

  return (
    <GloablButton
      className={className}
      text={translateText(children)}
      width={width}
      height="38px"
      borderRadius="6px"
      fontSize="12px"
      fontWeight={800}
      padding="0 18px"
      onClick={onClick}
      type={type}
      disabled={disabled}
      {...(styles[color] || styles.primary)}
    />
  );
}

export default AccountActionButton;
